import React, { useEffect, useState } from "react";
import { getDashboardUrl } from "../../../config";
import { Container, Row, Col, Button, Image } from "react-bootstrap";
import Header from "../../header/Header";
import Footer from "../../footer/Footer";
import Loader from "../../loader/Loader";
import SupportUserSection from "../../templates/SupportUserSection";
import UspSection from "../../templates/UspSection";
import PricingPlanCallToAction from "../../templates/PricingPlanCallToAction";
import Homepage3 from "../../../assets/images/index/Homepage3.jpg";
import PageCallToAction from "../PageCallToAction";
import screenie1 from "../../../assets/images/index/screenshots/screenie-1.jpg";
import screenie2 from "../../../assets/images/index/screenshots/screenie-2.jpg";
import screenie3 from "../../../assets/images/index/screenshots/screenie-3.jpg";
import grandMotherAndGrandson from "../../../assets/images/index/grandmother-and-grandson.jpg";
import quoteZoneLogo from "../../../assets/images/third-party-logos/quote-zone-logo.png";
import giftCard1 from "../../../assets/images/gift-cards/life-style-gift-card.jpg";
import giftCard2 from "../../../assets/images/gift-cards/john-lewis-gift-card.jpg";
import giftCard3 from "../../../assets/images/gift-cards/river-island-gift-card.jpg";
import giftCard4 from "../../../assets/images/gift-cards/one4all-gift-card.jpg";
import giftCard5 from "../../../assets/images/gift-cards/boots-gift-card.jpg";
import giftCard6 from "../../../assets/images/gift-cards/m-and-s-gift-card.jpg";
import TestimonialsSlider from "../../testimonialsSlider/TestimonialsSlider";
import sonCookingWithElderlyFather from "../../../assets/images/index/son-cooking-with-elderly-father.jpg";
import organiseEssentials from "../../../assets/images/index/organise_essentials.jpg";
import Homepage4 from "../../../assets/images/index/homepage4.jpg";
import trustedSupport from "../../../assets/images/index/trusted-support.png";
import Homepage6 from "../../../assets/images/index/Homepage6.jpg";
import Homepage5 from "../../../assets/images/index/Homepage5.jpg";
import liveStressFree from "../../../assets/images/index/live-stress-free.jpg";

const HowItWorks = () => {
  const [loading, setloading] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setloading(false);
    }, 500);
  }, []);

  return (
    <>
      <Header />
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="hero">
            <Container>
              <Row className="justify-content-between gx-xxl-0">
                <Col xl="13" xxl="12" xxxl="10">
                  <h1 className="h2 mb-5 mb-md-6 pt-xl-10 pt-xxxl-11">
                    Stay On Top — Together
                  </h1>
                  <p className="lead mb-5 text-dark">
                    With the support of someone you trust, Elderly Life helps
                    organise everyday life in one calm, secure place.
                  </p>
                  <div className="d-block d-xl-none mb-5">
                    <Image
                      src={Homepage3}
                      className="img-fluid rounded-4"
                      alt=""
                    />
                  </div>
                  <p className="lead mb-7 text-dark">
                    From reminders and subscriptions to Life Accounts, warranties
                    and important tasks, everything stays easier to manage — together.
                  </p>

                  <ul className="list-unstyled lead text-dark mb-8">
                    <li className="mb-3 d-flex align-items-start">
                      <span className="text-success me-3 fw-bold">✓</span>
                      <span>Track subscriptions & renewals</span>
                    </li>
                    <li className="mb-3 d-flex align-items-start">
                      <span className="text-success me-3 fw-bold">✓</span>
                      <span>Organise reminders & tasks</span>
                    </li>
                    <li className="mb-3 d-flex align-items-start">
                      <span className="text-success me-3 fw-bold">✓</span>
                      <span>Keep warranties & gift cards safe</span>
                    </li>
                    <li className="mb-3 d-flex align-items-start">
                      <span className="text-success me-3 fw-bold">✓</span>
                      <span>Invite trusted family support</span>
                    </li>
                    <li className="mb-0 d-flex align-items-start">
                      <span className="text-success me-3 fw-bold">✓</span>
                      <span>Stay prepared when life gets busy</span>
                    </li>
                  </ul>

                  <Button
                    href={`${getDashboardUrl()}/signup`}
                    target="_blank"
                    size="lg"
                  >
                    Start Free Trial
                  </Button>
                </Col>
                <Col xl="10" xxl="11" className="offset-xl-1 align-self-center d-none d-xl-block">
                  <Image
                    src={Homepage3}
                    className="img-fluid rounded-4"
                    alt=""
                  />
                </Col>
              </Row>
            </Container>
          </div>
          <Container>
            <section className="pb-11 pb-md-12 pt-xl-1 pb-xl-13 pt-xxxl-11 pb-xxxl-14">
              <Row className="justify-content-center mb-10 mb-md-11 mb-xl-12 mb-xxxl-13">
                <>
                  <h2 className="text-center mb-5 mb-md-6">
                    Support that goes beyond the basics.
                  </h2>
                  <p className="lead text-center mb-0">
                    Elderly Life helps you stay organised, supported and connected, keeping everyday life easier to manage for yourself or someone you care about.
                  </p>
                </>
              </Row>
              <Row className="align-items-center gy-5 gy-md-7 gy-xl-0 pb-10 pb-md-11 pb-xl-12 pb-xxxl-13">
                <Col className="d-none d-xl-block">
                  <Image
                    src={organiseEssentials}
                    className="img-object-fit-cover rounded-4"
                    alt="Son cooking with elderly father"
                  />
                </Col>
                <Col
                  xl="14"
                  xxl="13"
                  xxxl="12"
                  className="offset-xl-1 offset-xxl-2"
                >
                  <i className="fa fa-solid fa-1 text-primary fs-3 lh-base mb-2"></i>
                  <h3 className="mb-7">
                    Organise What Matters With Help When You Need It
                  </h3>
                  <div className="d-block d-xl-none mb-5">
                    <Image
                      src={organiseEssentials}
                      className="img-fluid rounded-4"
                      alt=""
                    />
                  </div>
                  <p className="lead mb-5">
                    <span className="fw-bold d-block">Track everyday life, together</span>
                    Stay on top of subscriptions, reminders, warranties and
                    important accounts with support from someone you trust.
                  </p>
                  <p className="lead mb-5">
                    <span className="fw-bold d-block">Keep important information organised</span>
                    Store key details securely in one calm, easy-to-manage
                    place so nothing important gets forgotten or lost.
                  </p>
                  <p className="lead mb-0">
                    <span className="fw-bold d-block">Support without taking away independence</span>
                    Trusted family members, friends or carers can quietly
                    help in the background only when needed.
                  </p>
                </Col>
              </Row>
              <Row className="align-items-center gy-5 gy-md-7 gy-xl-0 pb-10 pb-md-11 pb-xl-12 pb-xxxl-13">
                <Col className="order-xl-last offset-xl-1 offset-xxl-2 d-none d-xl-block">
                  <Image
                    src={Homepage4}
                    className="img-object-fit-cover rounded-4"
                    alt=""
                  />
                </Col>
                <Col xl="14" xxl="13" xxxl="12">
                  <i className="fa fa-solid fa-2 text-primary fs-3 lh-base mb-2"></i>
                  <h3 className="mb-7">
                    Stay Organised, Even When Life Gets Busy
                  </h3>
                  <div className="d-block d-xl-none mb-5">
                    <Image
                      src={Homepage4}
                      className="img-fluid rounded-4"
                      alt=""
                    />
                  </div>
                  <p className="lead mb-5">
                    <span className="fw-bold d-block">Life Accounts for everyday life</span>
                    Keep important memberships, reward schemes, provider details and
                    accounts organised in one calm, easy-to-manage place, so nothing
                    valuable or important gets forgotten.
                  </p>
                  <p className="lead mb-0">
                    <span className="fw-bold d-block">Support each other, quietly</span>
                    Trusted family members, friends or carers can help manage
                    shared tasks together, bringing greater peace of mind for everyone.
                  </p>
                </Col>
              </Row>
              <Row className="align-items-center gy-5 gy-md-7 gy-xl-0 pb-10 pb-md-11 pb-xl-12 pb-xxxl-13">
                <Col className="d-none d-xl-block">
                  <Image
                    src={trustedSupport}
                    className="img-object-fit-cover rounded-4"
                    alt=""
                  />
                </Col>
                <Col
                  xl="14"
                  xxl="13"
                  xxxl="12"
                  className="offset-xl-1 offset-xxl-2"
                >
                  <i className="fa fa-solid fa-3 text-primary fs-3 lh-base mb-2"></i>
                  <h3 className="mb-7">
                    Stay Connected With Trusted Support
                  </h3>
                  <div className="d-block d-xl-none mb-5">
                    <Image
                      src={trustedSupport}
                      className="img-fluid rounded-4"
                      alt=""
                    />
                  </div>
                  <p className="lead mb-5">
                    <span className="fw-bold d-block">Invite trusted support</span>
                    Add family members, friends or carers so they can quietly
                    help when needed, without taking away your independence.
                  </p>
                  <p className="lead mb-5">
                    <span className="fw-bold d-block">Share everyday tasks together</span>
                    Stay connected around reminders, important dates, subscriptions
                    and everyday organisation in one shared place.
                  </p>
                  <p className="lead mb-0">
                    <span className="fw-bold d-block">Support that works in the background</span>
                    Whether it’s a son, daughter, partner or family carer,
                    Elderly Life helps everyone stay informed, prepared and connected.
                  </p>
                </Col>
              </Row>
              <Row className="align-items-center gy-5 gy-md-7 gy-xl-0 pb-10 pb-md-11 pb-xl-12 pb-xxxl-13">
                <Col xl="14" xxl="13" xxxl="12">
                  <i className="fa fa-solid fa-4 text-primary fs-3 lh-base mb-2"></i>
                  <h3 className="mb-7">
                    Stay On Top Of Household Costs Together
                  </h3>
                  <div className="d-block d-xl-none mb-5">
                    <Image
                      src={Homepage5}
                      className="img-fluid rounded-4"
                      alt=""
                    />
                  </div>
                  <p className="lead mb-5">
                    <span className="fw-bold d-block">Keep track of subscriptions & renewals</span>
                    See household services, bills and recurring payments in one
                    organised place so nothing important gets overlooked.
                  </p>
                  <p className="lead mb-5">
                    <span className="fw-bold d-block">Support with everyday decisions</span>
                    Trusted family members or carers can help review household
                    costs together, making things easier to manage and less overwhelming.
                  </p>
                  <p className="lead mb-0">
                    <span className="fw-bold d-block">Reduce waste & unnecessary spending</span>
                    Spot forgotten subscriptions, unused services and upcoming
                    renewals before they become expensive surprise
                  </p>
                </Col>
                <Col className="order-xl-last offset-xl-1 offset-xxl-2 d-none d-xl-block">
                  <Image
                    src={Homepage5}
                    className="img-object-fit-cover rounded-4"
                    alt=""
                  />
                </Col>
              </Row>
              <Row className="align-items-center gy-5 gy-md-7 gy-xl-0 pb-10 pb-md-11 pb-xl-12 pb-xxxl-13">
                <Col className="order-xl-last offset-xl-1 offset-xxl-2 d-none d-xl-block">
                  <Image
                    src={Homepage6}
                    className="img-object-fit-cover rounded-4"
                    alt=""
                  />
                </Col>
                <Col xl="14" xxl="13" xxxl="12">
                  <i className="fa fa-solid fa-5 text-primary fs-3 lh-base mb-2"></i>
                  <h3 className="mb-7">
                    Stay In Control, With Privacy That Respects You
                  </h3>
                  <div className="d-block d-xl-none mb-5">
                    <Image
                      src={Homepage6}
                      className="img-fluid rounded-4"
                      alt=""
                    />
                  </div>
                  <p className="lead mb-5">
                    <span className="fw-bold d-block">You choose what gets shared</span>
                    Only add the information needed to help manage life’s
                    essentials, reminders and important tasks, without needing
                    sensitive personal details.
                  </p>
                  <p className="lead mb-5">
                    <span className="fw-bold d-block">Calm, secure organisation</span>
                    Keep important information organised in one private,
                    easy-to-manage place so nothing important gets forgotten or overlooked.
                  </p>
                  <p className="lead mb-0">
                    <span className="fw-bold d-block">Support without losing independence</span>
                    Trusted family members or carers can help when needed,
                    while you remain fully in control of what’s shared and when.
                  </p>
                </Col>
              </Row>
              <Row className="align-items-center gy-5 gy-md-7 gy-xl-0">
                <Col className="d-none d-xl-block">
                  <Image
                    src={liveStressFree}
                    className="img-object-fit-cover rounded-4"
                    alt=""
                  />
                </Col>
                <Col
                  xl="14"
                  xxl="13"
                  xxxl="12"
                  className="offset-xl-1 offset-xxl-2"
                >
                  <i className="fa fa-solid fa-6 text-primary fs-3 lh-base mb-2"></i>
                  <h3 className="mb-7">
                    Less Stress. More Time For What Matters.
                  </h3>
                  <div className="d-block d-xl-none mb-5">
                    <Image
                      src={liveStressFree}
                      className="img-fluid rounded-4"
                      alt=""
                    />
                  </div>
                  <p className="lead mb-5">
                    <span className="fw-bold d-block">Feel more organised every day</span>
                    Elderly Life helps keep track of reminders, renewals, tasks
                    and everyday essentials, so life feels calmer and easier to manage.
                  </p>
                  <p className="lead mb-0">
                    <span className="fw-bold d-block">Support when you need it</span>
                    Whether it’s family, friends or carers, trusted support
                    can quietly help in the background while you focus on living life your way.
                  </p>
                </Col>
              </Row>
            </section>
            <section className="pb-11 pb-md-12 pb-xl-13 pb-xxxl-14">
              <Row className="justify-content-center mb-10 mb-md-11 mb-xl-12">
                <Col xl="20" xxxl="17">
                  <h2 className="text-center mb-5 mb-md-6">
                    Technology with heart, built for the people who truly need
                    it
                  </h2>
                  <p className="lead text-center mb-0">
                    Elderly Life keeps life’s essentials organised, so you and
                    your loved ones can focus on what matters most.
                  </p>
                </Col>
              </Row>
              <Row className="row-cols-1 row-cols-md-2 row-cols-xl-4 justify-content-center gy-5 gx-xxxl-6">
                <Col>
                  <div className="bg-primary-light rounded-3 p-5 p-xl-6 p-xxxl-7 h-100">
                    <Row className="justify-content-center mb-7">
                      <Col xl="21" xxxl="18">
                        <h6 className="text-center mb-3">
                          Track every penny, from bills to Netflix
                        </h6>
                        <p className="small text-dark text-center mb-0">
                          Connect all your outgoings for hundreds of brands.
                        </p>
                      </Col>
                    </Row>
                    <Image
                      src={sonCookingWithElderlyFather}
                      className="img-object-fit-cover rounded-4 h-auto"
                      alt="Son cooking with elderly father"
                    />
                  </div>
                </Col>
                <Col>
                  <div className="bg-primary-light rounded-3 p-5 p-xl-6 p-xxxl-7 h-100">
                    <Row className="justify-content-center mb-7">
                      <Col xl="21" xxxl="18">
                        <h6 className="text-center mb-3">
                          Save money with Compare & Save
                        </h6>
                        <p className="small text-dark text-center mb-0">
                          Find better deals with our price comparison tool.
                        </p>
                      </Col>
                    </Row>
                    <Image
                      src={screenie2}
                      className="img-fluid rounded-3 shadow mb-3"
                      alt=""
                    />
                    <div className="d-flex justify-content-center align-items-center">
                      <div className="small-xs fw-semibold text-center">
                        Powered by
                      </div>
                      <Image
                        src={quoteZoneLogo}
                        height="16"
                        className="ms-2"
                        alt=""
                      />
                    </div>
                  </div>
                </Col>
                <Col>
                  <div className="bg-primary-light rounded-3 p-5 p-xl-6 p-xxxl-7 h-100">
                    <Row className="justify-content-center mb-7">
                      <Col xl="22" xxxl="19">
                        <h6 className="text-center mb-3">
                          Never forget another birthday present
                        </h6>
                        <p className="small text-dark text-center mb-0">
                          Set reminders for the theatre tickets, birthday’s and
                          more.
                        </p>
                      </Col>
                    </Row>
                    <div className="me-9 mb-5">
                      <Image
                        src={screenie3}
                        className="img-fluid rounded-3 shadow"
                        alt=""
                      />
                    </div>
                    <div className="ms-9 mt-4">
                      <Image
                        src={grandMotherAndGrandson}
                        className="img-fluid rounded-3 shadow"
                        alt=""
                      />
                    </div>
                  </div>
                </Col>
                <Col>
                  <div className="bg-primary-light rounded-3 p-5 p-xl-6 p-xxxl-7 h-100">
                    <Row className="justify-content-center mb-7">
                      <Col xl="23" xxxl="19">
                        <h6 className="text-center mb-3">
                          Keep track of gift cards and warranties
                        </h6>
                        <p className="small text-dark text-center mb-0">
                          Never let a gift card, voucher or warranty expire
                          again.
                        </p>
                      </Col>
                    </Row>
                    <Row className="justify-content-center gy-5 gx-xxxl-6 gy-xxxl-6">
                      <Col xs="auto">
                        <Image
                          src={giftCard1}
                          className="img-gift-card shadow rounded-1"
                          alt=""
                        />
                      </Col>
                      <Col xs="auto">
                        <Image
                          src={giftCard2}
                          className="img-gift-card shadow rounded-1"
                          alt=""
                        />
                      </Col>
                      <Col xs="auto">
                        <Image
                          src={giftCard3}
                          className="img-gift-card shadow rounded-1"
                          alt=""
                        />
                      </Col>
                      <Col xs="auto">
                        <Image
                          src={giftCard4}
                          className="img-gift-card shadow rounded-1"
                          alt=""
                        />
                      </Col>
                      <Col xs="auto">
                        <Image
                          src={giftCard5}
                          className="img-gift-card shadow rounded-1"
                          alt=""
                        />
                      </Col>
                      <Col xs="auto">
                        <Image
                          src={giftCard6}
                          className="img-gift-card shadow rounded-1"
                          alt=""
                        />
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </section>
            <SupportUserSection />
            <UspSection />
          </Container>
          {/* <TestimonialsSlider /> */}
          <PricingPlanCallToAction />
          <PageCallToAction messageContent="Start today, for yourself or someone you care about." />
          <Footer />
        </>
      )}
    </>
  );
};

export default HowItWorks;
